var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"exchange-marzs"},[_c('strong',[(_vm.ecbDifference)?[_vm._v(_vm._s(_vm._f("number")(_vm.ecbDifference))+"%")]:[_vm._v("N/A")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }